import PropTypes from "prop-types";

AccessWall.propTypes = {
  children: PropTypes.node,
};

export default function AccessWall({ children }) {
  return children;
}
